import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  forwardRef,
  Input,
  Renderer2,
} from "@angular/core";
import { RouterLink } from "@angular/router";
import {
  ToastBodyComponent,
  ToastCloseDirective,
  ToastComponent,
  ToastHeaderComponent,
  ToasterService,
} from "@coreui/angular-pro";
import { IconDirective } from "@coreui/icons-angular";
import type { RealtimeToastMetaLine } from "@infra-adapters/services/registration-review-notifications.service";

@Component({
  selector: "app-realtime-toast",
  standalone: true,
  templateUrl: "./realtime-toast.component.html",
  styleUrls: ["./realtime-toast.component.scss"],
  providers: [
    {
      provide: ToastComponent,
      useExisting: forwardRef(() => RealtimeToastComponent),
    },
  ],
  imports: [
    ToastHeaderComponent,
    ToastBodyComponent,
    ToastCloseDirective,
    RouterLink,
    IconDirective,
  ],
})
export class RealtimeToastComponent extends ToastComponent {
  @Input() title = "";
  @Input() body = "";
  @Input() subtitle = "";
  @Input() categoryLabel = "";
  @Input() iconName = "";
  @Input() lines: RealtimeToastMetaLine[] = [];
  @Input() timeLabel = "";
  @Input() closeButton = true;
  /** Ruta interna (ej. `['/prestaciones', id]`). */
  @Input() link: string[] | null = null;

  constructor(
    public override hostElement: ElementRef,
    public override renderer: Renderer2,
    public override toasterService: ToasterService,
    public override changeDetectorRef: ChangeDetectorRef,
  ) {
    super();
  }
}
